import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useVersionCheck } from '@/hooks/useVersionCheck';

export const UpdateNotification = () => {
  const { updateAvailable, latestVersion, forceUpdate, acknowledgeUpdate, refreshApp } = useVersionCheck();

  return (
    <AlertDialog open={updateAvailable}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {forceUpdate ? '⚠️ Critical Update Required' : '🎉 New Update Available!'}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {forceUpdate ? (
              <>
                Version <strong>{latestVersion}</strong> includes important fixes.
                <br />
                Please refresh to continue using the app.
              </>
            ) : (
              <>
                Version <strong>{latestVersion}</strong> is ready.
                <br />
                Refresh now to get the latest features and improvements.
              </>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          {!forceUpdate && (
            <AlertDialogCancel onClick={acknowledgeUpdate}>
              Remind Me Later
            </AlertDialogCancel>
          )}
          <AlertDialogAction onClick={refreshApp}>
            Refresh Now
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
